import type { $Fetch } from 'ofetch';
import type { SolicitacaoDescontoExtraGateway, ListSolicitacoesDescontoExtraParams } from '@/application/port/out/SolicitacaoDescontoExtraGateway';
import type { SolicitacaoDescontoExtra, DecidirDescontoExtraCommand } from '@/domain/model/SolicitacaoDescontoExtra';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/commerce/solicitacoes-desconto-extra';

/** HTTP gateway de Solicitações de Desconto Extra. Authority BE: `commerce:solicitacao_extra:*`. */
export class HttpSolicitacaoDescontoExtraGateway implements SolicitacaoDescontoExtraGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListSolicitacoesDescontoExtraParams): Promise<Page<SolicitacaoDescontoExtra>> {
    const query: Record<string, string | number> = { page: params.page, size: params.size };
    if (params.status) query.status = params.status;
    const res = await this.client<ApiResponse<Page<SolicitacaoDescontoExtra>>>(ROOT, { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async decidir(id: string, cmd: DecidirDescontoExtraCommand): Promise<SolicitacaoDescontoExtra> {
    const res = await this.client<ApiResponse<SolicitacaoDescontoExtra>>(
      `${ROOT}/${encodeURIComponent(id)}/decidir`, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
